import { render } from "./ContractAddenda.vue?vue&type=template&id=195b7c71"
import script from "./ContractAddenda.vue?vue&type=script&lang=js"
export * from "./ContractAddenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__